import { render, staticRenderFns } from "./mirrorTab.vue?vue&type=template&id=49854943&scoped=true"
import script from "./mirrorTab.vue?vue&type=script&lang=js"
export * from "./mirrorTab.vue?vue&type=script&lang=js"
import style0 from "./mirrorTab.vue?vue&type=style&index=0&id=49854943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49854943",
  null
  
)

export default component.exports